var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19231 3L10.3077 3C10.6901 3 11 3.30995 11 3.69231V9.80769C11 10.1901 10.6901 10.5 10.3077 10.5H4.19231C3.80995 10.5 3.5 10.1901 3.5 9.80769V3.69231C3.5 3.30995 3.80995 3 4.19231 3Z",
    fill: "#07A956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19231 3L10.3077 3C10.6901 3 11 3.30995 11 3.69231V9.80769C11 10.1901 10.6901 10.5 10.3077 10.5H4.19231C3.80995 10.5 3.5 10.1901 3.5 9.80769V3.69231C3.5 3.30995 3.80995 3 4.19231 3Z",
    fill: "url(#paint0_linear_2796_2565)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3H20.8077C21.1901 3 21.5 3.30995 21.5 3.69231V9.80769C21.5 10.1901 21.1901 10.5 20.8077 10.5H14.75C14.3676 10.5 14.0577 10.1901 14.0577 9.80769V3.69231C14.0577 3.30995 14.3676 3 14.75 3Z",
    fill: "#07A956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3H20.8077C21.1901 3 21.5 3.30995 21.5 3.69231V9.80769C21.5 10.1901 21.1901 10.5 20.8077 10.5H14.75C14.3676 10.5 14.0577 10.1901 14.0577 9.80769V3.69231C14.0577 3.30995 14.3676 3 14.75 3Z",
    fill: "url(#paint1_linear_2796_2565)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3077 13.5577H4.19231C3.80995 13.5577 3.5 13.8676 3.5 14.25L3.5 20.3077C3.5 20.6901 3.80995 21 4.19231 21H10.3077C10.6901 21 11 20.6901 11 20.3077V14.25C11 13.8676 10.6901 13.5577 10.3077 13.5577Z",
    fill: "#07A956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3077 13.5577H4.19231C3.80995 13.5577 3.5 13.8676 3.5 14.25L3.5 20.3077C3.5 20.6901 3.80995 21 4.19231 21H10.3077C10.6901 21 11 20.6901 11 20.3077V14.25C11 13.8676 10.6901 13.5577 10.3077 13.5577Z",
    fill: "url(#paint2_linear_2796_2565)",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.5577H20.8077C21.1901 13.5577 21.5 13.8676 21.5 14.25V20.3077C21.5 20.6901 21.1901 21 20.8077 21H14.75C14.3676 21 14.0577 20.6901 14.0577 20.3077V14.25C14.0577 13.8676 14.3676 13.5577 14.75 13.5577Z",
    fill: "#07A956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.5577H20.8077C21.1901 13.5577 21.5 13.8676 21.5 14.25V20.3077C21.5 20.6901 21.1901 21 20.8077 21H14.75C14.3676 21 14.0577 20.6901 14.0577 20.3077V14.25C14.0577 13.8676 14.3676 13.5577 14.75 13.5577Z",
    fill: "url(#paint3_linear_2796_2565)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2796_2565",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2796_2565",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2796_2565",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2796_2565",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "0afaf5401a6871afdd9898fbd02f2d85.svg";
export { ForwardRef as ReactComponent };